module.exports = __webpack_public_path__ + "img/huahua.8ce48a2e.png";